import session from "./session";

export default {
  fetchTelcoProducts(options) {
    return session.get(`/products/?product_kind=TELCO&include=lead&product_detail__automated=${options.automated}&product_detail__order_type__in=${options.order_type.join(',')}&product_detail__broadband_supplier__in=${options.broadband_supplier.join(',')}&status__in=${options.status.join(',')}&sort=${options.sort}&order=${options.order}&page=${options.page}&limit=${options.limit}`);
  },

  updateProvisioningInfo(product_id, data) {
    return session.patch(`/products/${product_id}/`, JSON.stringify(data));
  }
}